import { graphql } from '../__generated__/gql';

export const GET_EMOC_EMOC_BY_MOC_NUMBER = graphql(/* GraphQL */ `
  query EmocEmoc($mocNumber: String!, $assetId: Int!) {
    emocEmoc(mocNumber: $mocNumber, assetId: $assetId) {
      mocNumber
      mocDescription
      asset
      mocStatus
    }
  }
`);

export const GET_EMOC_BY_MOC_NUMBERS = graphql(/* GraphQL */ `
  query EmocsByEmocNumbers($mocNumbers: String!, $assetId: Int!) {
    emocsByEmocNumbers(mocNumbers: $mocNumbers, assetId: $assetId) {
      mocNumber
      mocDescription
      asset
      mocStatus
    }
  }
`);

export const GET_ALL_EMOCS = graphql(/* GraphQL */ `
  query EMocs($assetId: Int!) {
    allEmocs(assetId: $assetId) {
      assetId
      mocNumber
      mocId
      comments
      updatedBy
      updatedAt
      tarJobs {
        jobId
      }
      emocEmoc {
        mocDescription
        mocNumber
        asset
        comments
        mocInitiator
        mocStatus
        uRL
      }
    }
  }
`);

export const GET_JOB_EMOCS = graphql(/* GraphQL */ `
  query JobEMocs($jobId: Int!, $assetId: Int!) {
    emocsByJobId(jobId: $jobId, assetId: $assetId) {
      assetId
      mocNumber
      mocId
      comments
      updatedBy
      updatedAt
      tarJobs {
        jobId
      }
      emocEmoc {
        mocDescription
        mocNumber
        asset
        comments
        mocInitiator
        mocStatus
        uRL
      }
    }
  }
`);

export const CREATE_EMOC = graphql(/* GraphQL */ `
  mutation CreateEmoc($input: EmocInput!) {
    createEmoc(input: $input) {
      mocId
    }
  }
`);

export const UPDATE_EMOC = graphql(/* GraphQL */ `
  mutation UpdateEmoc($input: EmocInput!) {
    updateEmoc(input: $input) {
      mocId
    }
  }
`);

export const LINK_EMOC_JOBS = graphql(/* GraphQL */ `
  mutation LinkEmocJobs($mocId: Int!, $jobIds: [Int]!) {
    linkEmocJobs(mocId: $mocId, jobIds: $jobIds) {
      mocId
    }
  }
`);

export const REMOVE_EMOC = graphql(/* GraphQL */ `
  mutation RemoveEmoc($mocId: Int!) {
    removeEmoc(mocId: $mocId)
  }
`);
